import { useReducer, useEffect, useMemo } from 'react';
import useApi, { GET_CANNED_DASHBOARD_WIDGETS } from 'hooks/useApi';
import { initialState, reducer } from './config';
import * as ACTIONS from './actions';

const useFetchCannedDashboard = (masterObjectId, id) => {
  const [state, makeRequest] = useApi();
  const [cannedDashboardState, dispatch] = useReducer(reducer, initialState);
  const { isLoading, isError, data } = state;

  // Memoize the request in order to prevent unneeded API calls before the user gets redirected to the default dashboard id in case the ID is missing initially
  // makeRequest in it's core is just setState which is guaranteed to be static by React and it won't affect change
  useMemo(() => {
    const reqParams = id && GET_CANNED_DASHBOARD_WIDGETS({ masterObjectId, id });
    makeRequest(reqParams);
  }, [id, makeRequest, masterObjectId]);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isError) {
      return;
    }

    if (data) {
      dispatch({ type: ACTIONS.DASHBOARD_DATA_READY, payload: data });
    }
  }, [isLoading, isError, data]);

  return [state, cannedDashboardState, dispatch];
};

export default useFetchCannedDashboard;
